import { createSlice } from '@reduxjs/toolkit'
import { authApi } from 'redux/api/auth.api'
import { otpApi } from 'redux/api/otp.api'
import { shortlinkApi } from 'redux/api/shortlink.api'
import { PURGE } from 'redux-persist'

import { RootState } from '..'
import { megaActivationApi } from '../../api/mega-card-activation.api'
type InitialState = {
  access: string | null
  refresh: string | null
  isAuth: boolean
}

const initialState = {
  access: null,
  refresh: null,
  isAuth: false
} as InitialState

const authSlice = createSlice({
  name: 'authSlice',
  initialState,
  reducers: {
    setAuth: (state, { payload }) => {
      state.isAuth = true
      state.access = payload.access
      state.refresh = payload.refresh
    }
  },
  extraReducers: builder => {
    builder
      .addCase(PURGE, () => initialState)
      .addMatcher(authApi.endpoints.auth.matchFulfilled, (state, { payload }) => {
        state.isAuth = true
        state.access = payload.data.access
        state.refresh = payload.data.refresh
      })
      .addMatcher(otpApi.endpoints.otpVerify.matchFulfilled, (state, { payload }) => {
        state.isAuth = true
        state.access = payload.data.access
        state.refresh = payload.data.refresh
      })
      .addMatcher(shortlinkApi.endpoints.shortLinkDecode.matchFulfilled, (state, { payload }) => {
        state.isAuth = true
        state.access = payload.data.access
        state.refresh = payload.data.refresh
      })
      .addMatcher(megaActivationApi.endpoints.activationVerify.matchFulfilled, (state, { payload }) => {
        state.isAuth = true
        state.access = payload.data.access
        state.refresh = payload.data.refresh
      })
  }
})
export const isAuthSelector = (state: RootState) => state.auth.isAuth

export const { setAuth } = authSlice.actions
export default authSlice.reducer
